import { useState } from "react";

export const useCountryFormState = () => {

    const [formData, setFormData] = useState({
        name: "",
        code: "",
        active: true,
        iplCountryId: "",
        nameStatus: "unchecked",
        codeStatus: "unchecked",
        iplCountryIdStatus: "unchecked",
    });  

    const handleChange = (event) => {
        let formState = {...formData};
        if (event && event.target){
            switch (event.target.name){
                case "name": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,60})$");
                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }
                    break;
                }
                case "code": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,20})$");
                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }
                    break;
                }
                case "iplCountryId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,20})$");
                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }
                    break;
                }
            }
            formState[event.target.name] = event.target.value;
        }
        setFormData(formState);
    };


    const checkAllFields = () => {
        let allowSubmit = false;
        if (
        formData.nameStatus === "success" &&
        formData.codeStatus === "success" 
        ) {
        allowSubmit = true;
        } else {
        allowSubmit = false;
        }
        return allowSubmit;
    };


  return {
    formData,
    setFormData,
    handleChange,
    checkAllFields
  };
};
